module.exports = __webpack_public_path__ + "img/isPr_is1024_lost.3e310068.png";